import { render, staticRenderFns } from "./BotsSettings.vue?vue&type=template&id=13f13305&"
import script from "./BotsSettings.vue?vue&type=script&lang=js&"
export * from "./BotsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports